import { KeepoLoader } from "../KeepoLoader";
import { Background } from "../Modal/styles";
import { Container } from "./styles";

export const LoadingModal = () => {
  return (
    <Background>
      <Container role="status" aria-label="Loading">
        <KeepoLoader size={40} color="var(--color-neutral-white)" />
      </Container>
    </Background>
  );
};
